exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "a.team-select[data-v-556d5388]{border:1px solid #dfdfdf;border-radius:4px;padding:25px 40px;display:flex;width:418px;justify-content:space-between;margin:10px auto}a.team-select[data-v-556d5388]:hover{box-shadow:0 4px 8px 0 rgba(0,0,0,.2),0 6px 20px 0 rgba(0,0,0,.19)}a.team-select .team-name[data-v-556d5388]{float:left;font-family:Poppins,sans-serif;font-weight:500;font-size:14px;color:#16181f;text-align:left}a.team-select button[data-v-556d5388]{float:right;height:-webkit-fit-content;height:-moz-fit-content;height:fit-content}button.full-rounded[data-v-556d5388]{border-radius:20px}", ""]);

// exports
